export default __webpack_public_path__ + "static/media/Assault Order.f5197c4f.png";